import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getBusinessDocumentList(params) {
  return request({
    url: URL.sys.businessDocument,
    method: 'get',
    params
  })
}

export function queryPage(data) {
  return request({
    url: URL.sys.queryBusinessDocumentPage,
    method: 'post',
    data
  })
}

export function saveBusinessDocument(data) {
  return request({
    url: URL.sys.businessDocument,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function updateDocumentTypeUrlFunc(data) {
  return request({
    url: URL.sys.updateDocumentTypeUrl,
    method: 'post',
    data
  })
}
export function addBusinessDocumentHandler(data) {
  return request({
    url: URL.sys.addBusinessDocument,
    method: 'post',
    data
  })
}

export function delBusinessDocument(uuid) {
  return request({
    url: URL.sys.businessDocument + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
